import { createIsomorphicFn } from "@tanstack/react-start";
import z from "zod";

const publicEnvSchema = z.object({
  // API
  VITE_API_URL: z.string().min(1),
  // App
  VITE_DEFAULT_ORGANIZATION_SLUG: z.string().min(1),
  VITE_DEFAULT_PROJECT_SLUG: z.string().min(1),
});

export type PublicEnv = z.infer<typeof publicEnvSchema>;

const serverEnvSchema = z.object({
  // Server
  PORT: z
    .string()
    .refine((val) => !isNaN(parseInt(val)))
    .transform((val) => parseInt(val)),
  HOSTNAME: z.string().min(1),
  // API
  API_URL: z.string().min(1),
  API_KEY: z.string().min(1),
  // Fallback
  FALLBACK_ORGANIZATION_SLUG: z.string().min(1),
  FALLBACK_PROJECT_SLUG: z.string().min(1),
  // PDF
  PDF_API_URL: z.string().min(1),
  PDF_API_KEY: z.string().min(1),
});

export type ServerEnv = z.infer<typeof serverEnvSchema>;

const getPublicEnv = createIsomorphicFn()
  .client((): PublicEnv => publicEnvSchema.parse(import.meta.env))
  .server((): PublicEnv => publicEnvSchema.parse(process.env));

const getServerEnv = createIsomorphicFn()
  .server((): ServerEnv => serverEnvSchema.parse(process.env))
  .client(
    (): ServerEnv => ({
      PORT: 0,
      HOSTNAME: "",
      API_URL: "",
      API_KEY: "",
      FALLBACK_ORGANIZATION_SLUG: "",
      FALLBACK_PROJECT_SLUG: "",
      PDF_API_URL: "",
      PDF_API_KEY: "",
    }),
  );

export const publicEnv = getPublicEnv();
export const serverEnv = getServerEnv();
